import { firstValueFrom } from "rxjs";
import spaceIcon from "../assets/svg/space.svg";
import nebulaIcon from "../assets/svg/nebula.svg";

export class RequestError {
  constructor(status) {
    this.status = status;
  }
}

// ReleaseTrackerDataService is a class that handles all the release tracker data fetching.
export class ReleaseTrackerDataService {
  constructor(authCtx) {
    this.baseUrl = process.env.REACT_APP_DATA_SERVICE_URL;
    this.authCtx = authCtx;
  }

  async fetchOpts() {
    return {
      headers: await this.getHeaders(),
    };
  }

  async getHeaders() {
    return {
      Accept: "application/json",
      Authorization: `Bearer ${await this.getToken()}`,
    };
  }

  async getToken() {
    return await firstValueFrom(this.authCtx.getToken());
  }

  /**
   * /softwares
   */
  async getSoftwares() {
    const response = await fetch(
      `${this.baseUrl}/softwares`,
      await this.fetchOpts(),
    );
    if (response.status !== 200) {
      throw new RequestError(response.status);
    }
    return await response.json();
  }

  /**
   * /softwares/{name}
   */
  async getSoftwarePackage(name) {
    const response = await fetch(
      `${this.baseUrl}/softwares/${name}`,
      await this.fetchOpts(),
    );
    if (response.status !== 200) {
      throw new RequestError(response.status);
    }
    return await response.json();
  }

  /**
   * /softwares/{name}/mayors/{mayorCode}/versions
   */
  async getSoftwareVersions(name, code) {
    const response = await fetch(
      `${this.baseUrl}/softwares/${name}/mayors/${code}/versions`,
      await this.fetchOpts(),
    );
    if (response.status !== 200) {
      throw new RequestError(response.status);
    }
    return await response.json();
  }

  /**
   * /softwares/{name}/mayors/{mayorCode}/versions/{versionCode}
   */
  async getSoftwareVersion(name, mid, id) {
    const response = await fetch(
      `${this.baseUrl}/softwares/${name}/mayors/${mid}/versions/${id}`,
      await this.fetchOpts(),
    );
    if (response.status !== 200) {
      throw new RequestError(response.status);
    }
    return await response.json();
  }

  /**
   * /firmware-families/{deviceType}
   */
  async getFirmwareFamilies(deviceType) {
    const response = await fetch(
      `${this.baseUrl}/firmware-families/${deviceType}`,
      await this.fetchOpts(),
    );
    if (response.status !== 200) {
      throw new RequestError(response.status);
    }
    return await response.json();
  }

  /**
   * //firmware-families/{deviceType}/{deviceFamily}/firmwares
   */
  async getFirmwareFamiliesFirmwares(deviceType, deviceFamily) {
    const response = await fetch(
      `${this.baseUrl}/firmware-families/${deviceType}/${deviceFamily}/firmwares`,
      await this.fetchOpts(),
    );
    if (response.status !== 200) {
      throw new RequestError(response.status);
    }
    return await response.json();
  }

  /**
   * /firmware-families/{deviceType}/{deviceFamily}/firmwares/{firmwareName}/versions
   */
  async getFirmwareFamiliesFirmwareVersions(
    deviceType,
    deviceFamily,
    firmwareName,
  ) {
    const response = await fetch(
      `${this.baseUrl}/firmware-families/${deviceType}/${deviceFamily}/firmwares/${firmwareName}/versions`,
      await this.fetchOpts(),
    );
    if (response.status !== 200) {
      throw new RequestError(response.status);
    }
    return await response.json();
  }

  /**
   * /firmware-families/{deviceType}/{deviceFamily}/firmwares/{firmwareName}/versions/{versionCode}
   */
  async getFirmwareFamiliesFirmwareVersion(
    deviceType,
    deviceFamily,
    firmwareName,
    versionCode,
  ) {
    const response = await fetch(
      `${this.baseUrl}/firmware-families/${deviceType}/${deviceFamily}/firmwares/${firmwareName}/versions/${versionCode}`,
      await this.fetchOpts(),
    );
    if (response.status !== 200) {
      throw new RequestError(response.status);
    }
    return await response.json();
  }

  /**
   * /search?query={query}
   */
  async getSearch(query) {
    const response = await fetch(
      `${this.baseUrl}/search?query=${query}`,
      await this.fetchOpts(),
    );
    if (response.status !== 200) {
      throw new RequestError(response.status);
    }
    return await response.json();
  }
}

const softwareNameIdMap = {
  "PRO ACCESS SPACE": "space",
  NEBULA: "nebula",
};

const softwareNameImgMap = {
  "PRO ACCESS SPACE": spaceIcon,
  NEBULA: nebulaIcon,
};

export function softwareNameToImg(name) {
  return softwareNameImgMap[name];
}

export function softwareNameToId(name) {
  return softwareNameIdMap[name];
}

export function softwareIdToName(name) {
  for (let key in softwareNameIdMap) {
    if (softwareNameIdMap[key] === name) {
      return key;
    }
  }
  return null;
}
